import CtaLink from '@/storyblok/wirfuersklima/functionalComponents/CtaLink';
import HeadlineField, { HeadlineTag } from '@/storyblok/wirfuersklima/functionalComponents/HeadlineField';
import type { PartialTeaserBoxStoryblok } from '@/storyblok/wirfuersklima/types';
import { type SbBlokData, storyblokEditable } from '@storyblok/react/rsc';
import classNames from 'classnames';

import classes from './TeaserBox.module.scss';

const TeaserBox: React.FC<{ blok: PartialTeaserBoxStoryblok }> = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok as SbBlokData)} className={classNames(classes['teaser-box'])}>
      <CtaLink link={blok.cta_link} className="cta-box cta-box__inner" label={blok.headline}>
        <HeadlineField tag={HeadlineTag.H3} style={HeadlineTag.H4}>
          {blok.headline}
        </HeadlineField>
        <div className={classNames('icon-button', classes['teaser-box__button-external'])} />
      </CtaLink>
    </div>
  );
};

export default TeaserBox;
